registerComponent("pages/wealth", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * As duas rodas ("Gestão Discricionária" e "Advisory") eram slick com
 * `fade: true` e `infinite: true`: nada rolava, o slide ativo aparecia por
 * `opacity` e depois do último vinha o primeiro. É o `modo: 'troca'` do
 * `Asa.trilho` — quem decide o que fazer com `.is-ativo` é o LESS — mais
 * `circular: true`, que é o `infinite` sem clone nenhum.
 *
 * `.slick-prev1/2` e `.slick-next1/2` são classes de MARKUP deste Blade (o
 * legado as passava ao slick em `prevArrow`/`nextArrow`), não de DOM gerado:
 * ficam. Não há `dots: true` em nenhuma das duas, logo nenhum `pontos`.
 */

/**
 * @param {string} seletorDaLista
 * @param {string} seletorAnterior
 * @param {string} seletorProximo
 * @returns {void}
 */
function ligarRoda(seletorDaLista, seletorAnterior, seletorProximo) {
    const lista = component.querySelector(seletorDaLista);

    if (!lista) {
        return;
    }

    Asa.trilho(lista, {
        itens: '.module',
        modo: 'troca',
        circular: true,
        anterior: component.querySelector(seletorAnterior),
        proximo: component.querySelector(seletorProximo),
    });
}

ligarRoda('.slider', '.slick-prev1', '.slick-next1');
ligarRoda('.slider2', '.slick-prev2', '.slick-next2');

});
